import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from '@studio-freight/lenis';
import { Toaster } from "@/components/ui/sonner";

// Layout
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

// Pages
import Home from "@/pages/Home";
import Lineup from "@/pages/Lineup";
import Gallery from "@/pages/Gallery";
import FAQContact from "@/pages/FAQContact";
import Admin from "@/pages/Admin";

// Event Details Pages
import LocalArea from "@/pages/event-details/LocalArea";
import HowToGetThere from "@/pages/event-details/HowToGetThere";
import GateCamping from "@/pages/event-details/GateCamping";
import WhatToBring from "@/pages/event-details/WhatToBring";
import Sustainability from "@/pages/event-details/Sustainability";
import ServicesSafety from "@/pages/event-details/ServicesSafety";
import RulesTerms from "@/pages/event-details/RulesTerms";

// Applications Pages
import Musicians from "@/pages/applications/Musicians";
import VisualArtists from "@/pages/applications/VisualArtists";
import Performers from "@/pages/applications/Performers";
import WorkshopsHealing from "@/pages/applications/WorkshopsHealing";
import MarketStalls from "@/pages/applications/MarketStalls";
import Volunteers from "@/pages/applications/Volunteers";
import Media from "@/pages/applications/Media";
import SpacesThemeCamps from "@/pages/applications/SpacesThemeCamps";
import VJMultimedia from "@/pages/applications/VJMultimedia";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-ff-background min-h-screen">
        <BrowserRouter>
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/lineup" element={<Lineup />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/faq-contact" element={<FAQContact />} />
              <Route path="/admin" element={<Admin />} />
              
              {/* Event Details */}
              <Route path="/event-details/local-area" element={<LocalArea />} />
              <Route path="/event-details/how-to-get-there" element={<HowToGetThere />} />
              <Route path="/event-details/gate-camping" element={<GateCamping />} />
              <Route path="/event-details/what-to-bring" element={<WhatToBring />} />
              <Route path="/event-details/sustainability" element={<Sustainability />} />
              <Route path="/event-details/services-safety" element={<ServicesSafety />} />
              <Route path="/event-details/rules-terms" element={<RulesTerms />} />
              
              {/* Applications */}
              <Route path="/applications/musicians" element={<Musicians />} />
              <Route path="/applications/visual-artists" element={<VisualArtists />} />
              <Route path="/applications/performers" element={<Performers />} />
              <Route path="/applications/workshops-healing" element={<WorkshopsHealing />} />
              <Route path="/applications/market-stalls" element={<MarketStalls />} />
              <Route path="/applications/volunteers" element={<Volunteers />} />
              <Route path="/applications/media" element={<Media />} />
              <Route path="/applications/spaces-theme-camps" element={<SpacesThemeCamps />} />
              <Route path="/applications/vj-multimedia" element={<VJMultimedia />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
    </div>
  );
}

export default App;
